import  {useRef, useEffect, useState, use} from 'react'
import VideoNameAndActions from './VideoNameAndActions'
import CustomPlayer from './CustomPlayer'
import { useDispatch, useSelector } from 'react-redux'
import { getActiveVideos } from '../../actions/videoActions'
import { listPlaylistVideos } from '../../actions/PlaylistActions'


export default function VideoPlayer(props) {

    const videoPlayerRef = useRef()

    const { activeVideo } = useSelector(state => state.activeVideo)

    const dispatch = useDispatch()

    const { active_pl_id } = useSelector(state => state.userPlaylists)

    useEffect(()=>{
         videoPlayerRef.current && videoPlayerRef.current.scrollIntoView({ behavior: "smooth" })
        if(props.videoId && props.videoId!==undefined && props.videoId !== activeVideo.id){
            dispatch(getActiveVideos(props.videoId))
        }
    },[props.videoId])


    useEffect(()=>{

        if(parseInt(props.playlistId) !== active_pl_id && props.playlistId!==undefined && props.playlistId!==null){
            dispatch(listPlaylistVideos(props.playlistId))
        }
    },[props.playlistId])

  return (
    <div className = 'w-100 position-relative bg-bluedark pb-0 pb-md-5 d-flex flex-column justify-content-center align-items-center'
        ref = {videoPlayerRef}>
      <div className = "w-100 position-relative d-flex flex-column flex-lg-row align-items-start justify-content-center justify-content-lg-between">
        <div className="w-100  d-flex flex-column "
        >
          <div className = 'w-100 d-flex pb-4 pb-lg-0 position-relative d-flex flex-column'>
            {  activeVideo &&
                <CustomPlayer
                    playerRef = {props.playerRef}
                    setPlayerRef= {props.setPlayerRef}
                    video = {activeVideo}
                    playing = {props.playing}
                    setPlaying = {props.setPlaying}
                    searchParams = {props.searchParams}
                    setSearchParams = {props.setSearchParams}
                    handleRewind = {props.handleRewind}
                    analyzeRef = {props.analyzeRef}
                    videoClickHandler = {props.videoClickHandler}
                    filterList={props.filterList}
                />

          }
          <div className = 'd-flex'>
                {
                    activeVideo &&
                     <VideoNameAndActions
                        video = {activeVideo}
                        handleRewind = {props.handleRewind}
                        videoInfoExpanded = {props.videoInfoExpanded}
                        setVideoInfoExpanded = {props.setVideoInfoExpanded}
                    />
                }
          </div>
          </div>
        </div>
      </div>
    </div>
  )

}

